import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {UserService} from "./user.service";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(
    private router: Router,
    private userService: UserService
  ) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const token: string | null = localStorage.getItem('jwt');
    const roles = this.userService.getRoles();

    if (token === null) {
      this.router.navigate(['/login']);
      return false;
    }

    if (route.routeConfig?.path === 'creation') {
      return this.userService.canEdit()
    }

    if (route.routeConfig?.path === 'miniliens') {
      return roles.includes('SUPER_CEM')
    }

    if (route.routeConfig?.path === 'users') {
      return this.userService.canEdit()
    }

    return true;
  }
}
